import React from 'react';
import { Tag, Tooltip, Typography } from 'antd';
import { HistoryOutlined, RedoOutlined } from '@ant-design/icons';

const fmtMesAnio = (d) => {
  if (!d) return '';
  const fecha = new Date(d);
  if (Number.isNaN(fecha.getTime())) return '';
  return fecha.toLocaleDateString('es-CL', { month: 'short', year: 'numeric' });
};

/**
 * Celda del problema: el ítem del checklist es el título, el texto del técnico
 * baja a segundo plano. Hoy hay cientos de hallazgos cuya descripción es solo
 * "Requiere reparación." — el ítem es lo que identifica el problema.
 */
function GrupoRow({ grupo }) {
  const titulo = grupo.item_titulo || grupo.descripcion || '—';
  const veces = grupo.veces_visto === 1 ? 'Visto 1 vez' : `Visto ${grupo.veces_visto} veces`;
  const desde = fmtMesAnio(grupo.first_seen_at);

  return (
    <div>
      <div className="flex flex-wrap items-center gap-2">
        <Tooltip title={grupo.descripcion} mouseEnterDelay={0.3}>
          <span className="text-sm font-medium text-slate-700">{titulo}</span>
        </Tooltip>
        {grupo.cronico ? (
          <Tag color="volcano" icon={<HistoryOutlined />}>
            Recurrente
          </Tag>
        ) : null}
        {grupo.regreso ? (
          <Tag color="red" icon={<RedoOutlined />}>
            Volvió a aparecer
          </Tag>
        ) : null}
      </div>
      <Typography.Text type="secondary" className="text-xs">
        {veces}
        {desde ? ` · Desde ${desde}` : ''}
      </Typography.Text>
    </div>
  );
}

export default GrupoRow;
